// v2/hooks/useAdminOrders.js — /api/v2/admin/orders/
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, apiPost, qs } from '../utils/api';

export default function useAdminOrders(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  const yenile = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet(`/v2/admin/orders/${sorgu}`, { signal: ctrl.signal });
      if (ctrl.signal.aborted) return;
      if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
      setData({
        ...veri,
        items: Array.isArray(veri.items) ? veri.items : [],
        summary: veri.summary || {},
        window: veri.window || {},
      });
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      setError((e && e.message) || 'Liste alınamadı');
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, [sorgu]);

  useEffect(() => {
    yenile();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  }, [yenile]);

  return { data, loading, error, yenile };
}

/** Bir siparisin kalemleri (satir acilinca cagrilir) */
export const siparisKalemleri = (nolar) =>
  apiGet(`/v2/admin/orders/lines/${qs({ nos: (nolar || []).join(',') })}`);

/** Siparis silme. onay=false -> onizleme (hicbir sey silinmez), true -> siler.
 *  Transfer edilmis sipariste onayNo, siparis numaralarindan biri olmalidir. */
export const siparisSil = (nolar, onay = false, onayNo = '') =>
  apiPost('/v2/admin/orders/delete/', onay
    ? { nos: nolar, confirm: true, confirm_no: onayNo }
    : { nos: nolar });
